import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import ChartImageCard from '../ChartImageCard/ChartImageCard';
import Modal from '../common/Modal/Modal';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';

interface VesselsCardData {
  title?: string;
  src?: string;
  alt?: string;
}

const modalImageStyle: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: '90vh',
  height: 'auto',
  borderRadius: '6px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
};

export default function VesselsCard(props: RegistryComponentProps): React.ReactElement {
  const [showModal, setShowModal] = useState(false);
  const data = getRegistryData<VesselsCardData>(props);
  const title = data.title ?? 'Vessels';
  const src = data.src ?? '/NE_MULTISPECIES_-_LARGE_MESH_vessels.png';
  const alt = data.alt ?? 'NE Multispecies - Large Mesh - Vessels';

  return (
    <>
      <ChartImageCard title={title} src={src} alt={alt} onClick={() => setShowModal(true)} />
      {showModal &&
        createPortal(
          <Modal
            title={title}
            onClose={() => setShowModal(false)}
            size="extra-large"
            transparentBackdrop={true}
            parameterStyle={true}
            {...({ customMaxWidth: '95vw', customMaxHeight: '95vh' } as Record<string, unknown>)}
            bodyStyle={{
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={src} alt={alt} style={modalImageStyle} />
          </Modal>,
          document.body
        )}
    </>
  );
}
